import Lookup from './lookup.js';

export default class IssuerPassport extends Lookup
{
    
}

